import { useContext, useEffect, useRef, useState } from 'react';
import { getDashboardEmbeddedRegisteredAccess } from '../../services/quicksight';
import { Alert, Card, CircularProgress } from "@mui/material";
import { AccountContext } from '../../authentication/Account';
import { getRutaQuicksightTv } from '../../services/general';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { decodeFromBase64 } from '../../commons/encoding';
import { useLocation } from "react-router-dom";
import usePageTiming from '../../hooks/general/usePageTiming';

export const QuickSightTV = () => {
    const location = useLocation();
    const { id, token } = useParams();
    const stringToken = decodeFromBase64(token || "");
    const [email, password, idAreaOperacion] = stringToken?.split("&");
    const pageTiming = usePageTiming(idAreaOperacion);
    const invalidToken = (!email || !password || !idAreaOperacion || !token);
    const { authenticate, getSession } = useContext(AccountContext);
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const endpointExternosIndex = useRef(0);
    const totalEndpointExternosIterations = useRef({ count: 0, time: 0 });
    const reloadMiliseconds = 300000;
    const thirtyMinutesMiliseconds = 1800000;
    const [embeddedState, setEmbeddedState] = useState({
        isLoading: true,
        url: ''
    });
    const [endpointsExternos, setEndpointsExternos] = useState([]);
    const [mensajeError, setMensajeError] = useState(null);
    const onHandleLogin = () => {

        authenticate(email, password)
            .then((data) => {
                setIsLoggedIn(true)
            })
            .catch((err) => {
                console.error("Failed to login", err);
                switch (String(err)) {
                    case "UserNotConfirmedException: User is not confirmed.":
                        setMensajeError("No ha confirmado email");
                        break;
                    case "NotAuthorizedException: Incorrect username or password.":
                        setMensajeError("Username o contraseña incorrecta");
                        break;
                    case "InvalidParameterException: Missing required parameter":
                        setMensajeError("Falta el parámetro obligatorio");
                        break;
                    case "NotAuthorizedException: Password attempts exceeded":
                        setMensajeError("Se superaron los intentos de contraseña");
                        break;
                    default:
                        break;
                }
                setEmbeddedState({ ...embeddedState, isLoading: false })
            });
    };

    useEffect(() => {
        getSession()
            .then((session) => {
                setIsLoggedIn(true);
                try {
                    getRutaQuicksightTv(idAreaOperacion)
                        .then((resp) => {
                            if (resp) {
                                if (resp.data && resp.data[id]) {
                                    setEndpointsExternos(resp.data[id])
                                } else {
                                    setEmbeddedState({ ...embeddedState, isLoading: false })

                                }
                            }
                        })
                        .catch((err) => console.log(err));

                } catch (err) {
                    console.log(err);
                }
            })
            .catch((e) => {
                onHandleLogin()
            });
    }, [isLoggedIn])

    useEffect(() => {
        if (!endpointsExternos || endpointsExternos.length === 0) return;

        let isMounted = true;

        const fetchData = async () => {
            const currentEndpointExterno = endpointsExternos[endpointExternosIndex.current];
            setEmbeddedState((prev) => ({ ...prev, isLoading: true }));
            try {
                const resp = await getDashboardEmbeddedRegisteredAccess(currentEndpointExterno.dashboard_id);
                if (isMounted) {
                    setEmbeddedState({ isLoading: false, url: resp?.data?.embedUrl });
                }
            } catch (error) {
                if (isMounted) {
                    setEmbeddedState((prev) => ({ ...prev, isLoading: false }));
                }
            }
        };

        fetchData();

        const refreshDashboardInterval = setInterval(() => {
            if (endpointExternosIndex.current == endpointsExternos.length - 1) totalEndpointExternosIterations.current = { count: totalEndpointExternosIterations.current.count += 1, time: totalEndpointExternosIterations.current.time += reloadMiliseconds };
            if (totalEndpointExternosIterations.current.count >= 3 && totalEndpointExternosIterations.current?.time >= thirtyMinutesMiliseconds) window.location.reload();
            endpointExternosIndex.current =
                endpointExternosIndex.current < endpointsExternos.length - 1
                    ? endpointExternosIndex.current + 1
                    : 0;
            fetchData();
        }, reloadMiliseconds);

        return () => {
            isMounted = false;
            pageTiming.sendTime(location.pathname)
            clearInterval(refreshDashboardInterval);
        };
    }, [endpointsExternos]);

    if (embeddedState.isLoading) {
        return (
            <>
                <Card sx={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        <CircularProgress style={{ color: "#2f4554" }} size={100} />
                    </div>
                </Card>
            </>
        );
    }
    if (!isLoggedIn) {
        return (
            <>
                <Card sx={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Alert style={{ fontSize: 16 }} severity="warning">Sin sesión activa</Alert>
                </Card>
            </>
        )
    }
    if (invalidToken && !embeddedState.isLoading) {
        return (
            <>
                <Card sx={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Alert style={{ fontSize: 16 }} severity="warning">El token ingresado es invalido</Alert>
                </Card>
            </>
        )
    }
    if (endpointsExternos?.length <= 0 && !embeddedState.isLoading) {
        return (
            <>
                <Card sx={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Alert style={{ fontSize: 16 }} severity="warning">No hay dashboard disponible o el token ha sido alterado</Alert>
                </Card>
            </>
        )
    }
    if (mensajeError && !embeddedState.isLoading) {
        return (
            <>
                <Card sx={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Alert style={{ fontSize: 16 }} severity="warning">{mensajeError}</Alert>
                </Card>
            </>
        )
    }
    return (
        <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column' }}>
            <iframe
                style={{ flexGrow: 1, border: 'none' }}
                src={embeddedState.url}
                allowFullScreen={true}
            ></iframe>
        </div>
    )
};
